import React, { useState } from 'react';
import classnames from 'classnames';
import { FaCommentDots } from 'react-icons/fa';

// Served from public/ rather than imported from src/: a missing import would
// fail the webpack build, whereas this degrades to the fallback icon below.
const AVATAR_SRC = `${process.env.PUBLIC_URL}/inna.png`;
const SHOES_SRC = `${process.env.PUBLIC_URL}/inna-in-shoes.png`;

/**
 * INNA artwork. Decorative - every use sits next to her name or inside a
 * labelled control, so it carries an empty alt.
 */
const InnaAvatar = ({ size = 32, className, variant = 'avatar' }) => {
    // The larger illustration is used only on the full-page welcome. Falling
    // back through the regular avatar keeps the chat usable if either public
    // asset is unavailable or still being refreshed by the browser.
    const sources = variant === 'shoes' ? [SHOES_SRC, AVATAR_SRC] : [AVATAR_SRC];
    const [sourceIndex, setSourceIndex] = useState(0);
    const src = sources[sourceIndex];

    if (!src) {
        return <FaCommentDots className={classnames('inna-avatar-fallback', className)} />;
    }

    return (
        <img
            src={src}
            alt=""
            width={size}
            height={size}
            className={classnames('inna-avatar', className)}
            onError={() => setSourceIndex((index) => index + 1)}
        />
    );
};

export default InnaAvatar;
